<template>
  <div>
    <div class="jumbotron">
      <div class="container marketing">
        <div class="row">
          <div class="col-lg-10">
            <a-descriptions :title="user.nickname">
              <!--              <a-descriptions-item label="昨日盈利">-->
              <!--                {{ profitData.yesterday_profit_amount| toDecimal }}（更新:{{ profitData.update_time }}）-->
              <!--              </a-descriptions-item>-->
              <!--              <br/>-->
              <!--              <a-descriptions-item label="微信充值总额">-->
              <!--                {{ profitData.sum_wx | toDecimal }}-->
              <!--              </a-descriptions-item>-->
              <a-descriptions-item label="可提现余额">
                <span style="color: rgb(253,138,26)">{{
                    ((profitData.balance - 1990) <= 0 ? 0.0 : profitData.balance - 1990 )| toDecimal
                  }} (联系客服提现)</span>
              </a-descriptions-item>
              <a-descriptions-item label="代理链接">
                {{ profitData.domain}}
              </a-descriptions-item>
              <a-descriptions-item label="余额">
                {{ (profitData.balance)| toDecimal }}
              </a-descriptions-item>

            </a-descriptions>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10">
            <span style="font-weight: 700;margin-right: 7px">总盈利: </span> {{
              profitData.sum_profit | toDecimal
            }}元【账号与订单-账单记录】可查看收益明细
          </div>
          <div class="col-lg-10" style="margin-top: 15px">
            <span style="font-weight: 700;margin-right: 7px">商品提价百分比:</span> <span
              style="color: rgb(253,138,26);font-weight: 700">{{ (profitData.improve_rate - 1000) / 10 }}%</span>（例如：若商品成本价是10元，提价百分比为30%，则零售价为13元，盈利
            = 零售价 - 成本价）
            <button type="button" class="btn btn-primary"
                    style="background:rgb(253,138,26);border: none;margin-bottom: 10px"
                    @click="edit">
              修改
            </button>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="visible"
             title="修改提价百分比"
             :confirm-loading="confirmLoading"
             @ok="handleOk"
             cancelText="取消"
             okText="确定">
      <a-form-model :layout="form.layout"
                    :model="form"
                    :rules="rules"
                    ref="ruleForm"
                    v-bind="formItemLayout">
        <a-form-model-item label="百分比"
                           prop="amount">
          <a-input v-model="form.amount"
                   type="number"
                   placeholder="请填写数字"
                   suffix="%"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>


    <Child2 ref="child2"></Child2>
  </div>
</template>
<script>
import {
  getProfit, changImproveRate
} from "@/api/mine";
import Child2 from '../components/child-2'

export default {
  components: {
    Child2
  },
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
  },
  data() {
    return {
      user: this.$store.state.user,
      lists: this.$store.state.user,
      profitData: {},
      visible: false,
      confirmLoading: false,
      form: {
        layout: "vertical",
        amount: "",
      },
      rules: {
        amount: [
          {required: true, message: "请填写百分比", trigger: "change"},
        ],
      },
    };
  },
  mounted() {
    this.$refs.child2.getUserList();
    this.getProfitData();
  },
  methods: {
    getProfitData() {
      getProfit().then((res) => {
        if (res.code == 200) {
          this.profitData = res.data;
        }
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          if (this.form.amount > 50) {
            this.$message.error('百分比不得大于50');
            this.confirmLoading = false;
            return
          }
          changImproveRate(this.form.amount * 10 + 1000).then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功")
            }
          });
          this.confirmLoading = false;
          this.visible = false;
          this.getProfitData()
        }
      });
    },
    edit() {
      this.visible = true
    },
  },
};
</script>
<style scoped>
.marketing {
  margin-top: 80px;
}

.recharge {
  color: #ff4c34;
}
</style>